import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import * as React from 'react'

export default function DepartureDateTimeFieldValue({
  value,
  setValue,
  title,
  isDisable,
  departureTimezone
}) {
  console.log('valueDeparture:', value)
  console.log('valueDeparture dayjs:', dayjs(value))
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DateTimePicker', 'DateTimePicker']}>
        <DateTimePicker
          disabled={isDisable}
          timezone={departureTimezone}
          value={dayjs(value)}
          onChange={(newValue) => setValue(newValue)}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -10] // move it upward
                  }
                },
                {
                  name: 'preventOverflow',
                  options: {
                    altAxis: true,
                    tether: false
                  }
                },
                {
                  name: 'flip',
                  options: {
                    fallbackPlacements: ['top']
                  }
                }
              ]
            }
          }}
          sx={{
            minHeight: '50px',
            '& .MuiInputLabel-root': {
              color: '#212529',
              padding: '4px'
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: '#212529'
            },
            '& .MuiOutlinedInput-root': {
              height: '43px',
              '& fieldset': {
                borderColor: '#ccc'
              },
              '&:hover fieldset': {
                borderColor: '#a3a3a3b3',
                borderWidth: '0.3px'
              },
              '&.Mui-focused fieldset': {
                borderColor: '#a3a3a3b3',
                borderWidth: '0.3px'
              }
            },
            '& .MuiInputBase-input::placeholder': {
              fontFamily: '"Poppins", sans-serif',
              fontSize: '12px',
              fontWeight: '400',
              color: '#858585'
            }
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}
